import { createFileRoute } from "@tanstack/react-router";

import LeagueDetailsForm from "@/components/LeagueProfile/LeagueDetailsForm";

const Component = () => {
  const { leagueUuid } = Route.useParams();

  return <LeagueDetailsForm leagueUuid={leagueUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/events/series/$leagueUuid/profile/details")({
  component: Component,
});
